var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      staticClass: "dialog-box-custom",
      attrs: { width: "32rem", persistent: _vm.isPersistent },
      on: {
        keydown: function($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          ) {
            return null
          }
          $event.preventDefault()
          return _vm.executeMainAction.apply(null, arguments)
        }
      },
      model: {
        value: _vm.isOpen,
        callback: function($$v) {
          _vm.isOpen = $$v
        },
        expression: "isOpen"
      }
    },
    [
      _c("v-card", { staticClass: "card-custom", style: _vm.cardStyle }, [
        _vm.title
          ? _c("div", { staticClass: "title-custom" }, [
              _c("span", [_vm._v(_vm._s(_vm.title))])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "content-custom" }, [_vm._t("content")], 2),
        _vm._v(" "),
        _vm.mainActionLabel || _vm.extraActionLabel
          ? _c(
              "div",
              { staticClass: "action-buttons-div-custom" },
              [_vm._t("actionButtons")],
              2
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7d75333c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d75333c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/newComponents/_Molecules/DialogContent.vue
// module id = null
// module chunks = 